import l10n from "../l10n/localization";
import * as utils from "./utils";

export function clientToForm(client) {
    let cleanedClient = Object.assign({}, client);

    if (utils.notNullNorUndefined(cleanedClient.currency) && cleanedClient.currency.id !== undefined) {
        cleanedClient.currency = cleanedClient.currency.id;
    }

    return cleanedClient;
}

export function flattenCurrency(clients) {
    return clients.map((item) => {
        if (utils.notNullNorUndefined(item.currency)) {
            return {...item, currencyName: item.currency.name};
        }
        return item;
    })
}

export function clientToSelect(clients, add = false) {
    let cleanedClients = [];

    if(add){
        cleanedClients.push({
            label: l10n.client.button.add,
            value: 0,
            item: null,
        });
    }

    clients.map((item) => (
        cleanedClients.push({
            label: item.name,
            value: item.id,
            item: item,
        })
    ));

    return cleanedClients;
}


// WEBPACK FOOTER //
// ./src/utils/client.js